import { AxiosResponse } from 'axios';

import { QueryObserverOptions, useQueryClient } from '@tanstack/react-query';

import { API_VERSION_V2 } from '~/constants';
import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

export const useGetContractTemplate = () => {
  const queryClient = useQueryClient();

  const requestGetContractTemplate = async ({
    queryConfig,
    onSuccess,
    onError,
  }: {
    queryConfig?: Omit<QueryObserverOptions<AxiosResponse<string>>, 'queryKey' | 'queryFn'>;
    onSuccess?: (response: string) => void;
    onError?: (error: TypeErrorFormat) => void;
  } = {}) => {
    const endpoint = '/labor/contracts/preview';
    const REQUEST_CONTRACT_TEMPLATE_TIMEOUT = 30 * 1000;

    const query = queryClient.ensureQueryData<AxiosResponse<string>>({
      queryKey: ['labor', 'contracts', 'preview'],
      queryFn: () =>
        axiosInstance.get<string>(endpoint, {
          timeout: REQUEST_CONTRACT_TEMPLATE_TIMEOUT,
          headers: { version: API_VERSION_V2 },
        }),
      ...queryConfig,
      gcTime: 0,
    });

    return requestHelper(() => query, onSuccess, onError);
  };

  return requestGetContractTemplate;
};
